
import { ICardNetTyp_PinTrialLimFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/cardNetTyp_PinTrialLimFormMeta';
import { IEmbossedDataFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/embossedDataFormMeta';
import { IEncodedTrackFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/encodedTrackFormMeta';
import { I_InternetMailOrderFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/internetMailOrderFormMeta';
import { TMagneticTapeApplication } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/magneticTapeApplicationFormMeta';
import { IServiceCodeFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/magneticTapeApplication/serviceCodeFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput, { INPUT_TYPE } from '@Modules/core/components/form/CustomInput';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
    meta: TMagneticTapeApplication
} & Partial<TFormUIProps>;

const MagneticTapeApplicationFormUI: React.FC<Props> = ({ isLoading, meta }) => {

    const {cardNetworkType_PinTrialLimitFormMeta, embossedDataFormMeta, encodedTrackFormMeta, internetMailOrderFormMeta, serviceCodeFormMeta} = meta;

    const { register, formState: {errors} } = useFormContext();
    
    return (
        <>
            <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>

                <CC.SimpleGrid columns={1} gridRowGap={4} columnGap={4} my={4}>
                    <CC.SimpleGrid columns={{ base: 1, sm: 2 }} gridRowGap={4} columnGap={10} my={4}>
                        {displayCustomInputs<ICardNetTyp_PinTrialLimFormMeta>(
                        cardNetworkType_PinTrialLimitFormMeta,
                        register,
                        errors,
                        isLoading
                        )}
                    </CC.SimpleGrid>
                    
                    <CustomFieldSet title={"Internet / Mail Order"}>
                        <CC.SimpleGrid columns={{ base: 2, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>
                            {displayCustomInputs<I_InternetMailOrderFormMeta>(
                            internetMailOrderFormMeta,
                            register,
                            errors,
                            isLoading
                            )}
                        </CC.SimpleGrid>

                    </CustomFieldSet>      
                </CC.SimpleGrid>

                <CustomFieldSet title={"Code Service"}>
                    <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>
                        {displayCustomInputs<IServiceCodeFormMeta>(
                        serviceCodeFormMeta,
                        register,
                        errors,
                        isLoading
                        )}
                    </CC.SimpleGrid>

                </CustomFieldSet>  
                
                <CustomFieldSet title={"Piste encodée"}>
                    
                    <CC.SimpleGrid columns={{ base: 2, lg: 2 }} gridRowGap={8} alignItems={"center"} columnGap={0} >
                        {
                            getFormFieldsName(encodedTrackFormMeta).map((input, index) => (
                                    <CustomFormControl key={index}  isLoading={isLoading} isInvalid={!!errors[encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].name]}>
                                        {
                                            encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].type === INPUT_TYPE.CHECKBOX ? 
                                            <CustomInput hasError={errors[encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].name]} register={register(encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].name)} meta={encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta]}/> 
                                            : 
                                            <CC.HStack flexBasis={2} flexGrow={2} >
                                                <CC.Text mr="2">{encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].label}</CC.Text> <CustomInput hasError={errors[encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].name]} register={register(encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta].name)} meta={encodedTrackFormMeta[input as keyof IEncodedTrackFormMeta]}/>
                                            </CC.HStack>
                                        }
                                    </CustomFormControl>
                            ))
                        }
                    </CC.SimpleGrid>

                </CustomFieldSet>  

                <CustomFieldSet title={"Donnée Embossée"}>
                    <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>
                        {displayCustomInputs<IEmbossedDataFormMeta>(
                        embossedDataFormMeta,
                        register,
                        errors,
                        isLoading
                        )}
                    </CC.SimpleGrid>

                </CustomFieldSet>  


            </CC.SimpleGrid>
        </>
    );
};

export default MagneticTapeApplicationFormUI;
